<template>
  <div class="columns is-marginless infoBorderReseau" :class="{'selectt': infoReseauxLc.select}">
    <div class="column is-narrow is-paddingless position_relative">
      <div class="positionDot">
      </div>
      <img class="sizeImgReseau" :src="url">
      <div class="pointer level bgBlur">
        <div class="level-left"></div>
        <div
          class="level-right"
          v-if="getTarif">
          <p class="p_size18 has-text-weight-bold has-text-white goToLeft">
            {{tarif(getTarif)}} HT
          </p>
        </div>
      </div>
    </div>
    <div class="column is-paddingless has-background-white position_relative">
      <div class="padding_medium">
        <p @click="show = true" class="pointer is-size-7">
          <label class="has-text-default">Nom du réseau</label> <br>
          <strong class="p_size16 has-text-weight-bold has-text-link">
            {{infoReseauxLc.libelle}}
          </strong>
        </p>
        <div class="level is-marginless">
          <div class="level-left is-marginless">
            <p
              class="p_size16 has-text-weight-bold has-text-link"
              v-if="infoReseauxLc.extensionOpportunite.tarifAnnuel">
              {{tarif}}
            </p>
          </div>
          <div class="level-right bottomViolet">
          </div>
        </div>
        <div
          @click="show = true"
          class="pointer columns is-multiline is-marginless is-gap color-icon">
          <div
            v-if="infoReseauxLc.extensionOpportunite.duree"
            class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default"> Durée </label><br>
                <p class="p_size14 has-text-link has-text-weight-bold">
                  {{infoReseauxLc.extensionOpportunite.duree}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-half is-paddingless bottomViolet"
            v-if="infoReseauxLc.nbFaces">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Nombre de faces </label><br>
                <p class="p_size14 has-text-link has-text-weight-bold">
                  {{infoReseauxLc.nbFaces}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="infoReseauxLc.extensionOpportunite.date"
            class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="calendar-check"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Disponible le : </label><br>
                <p class="p_size14 has-text-link has-text-weight-bold">
                  {{infoReseauxLc.extensionOpportunite.date}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="city"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Ville </label><br>
                <p class="p_size14 has-text-link has-text-weight-bold">{{infoReseauxLc.ville}}</p>
              </div>
            </div>
          </div>
          <div class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Format </label><br>
                <p class="p_size14 has-text-link has-text-weight-bold">
                  {{infoReseauxLc.format}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="column is-12 is-paddingless bottomViolet"
            v-if="infoReseauxLc.extensionOpportunite.commentaire">
            <div class="media">
              <div class="media-content is-size-7">
                <label class="has-text-weight-bold has-text-link p_size14">
                  Commentaire : </label><br>
                <p class="p_size12 has-text-default has-text-link">
                  {{infoReseauxLc.extensionOpportunite.commentaire}}
                </p>
              </div>
            </div>
            </div>
        </div>
      </div>
    </div>
    <div class="column is-narrow">
      <div class="has-text-centered mb-btnaction">
        <div class="icon-forme pointer" :class="{'icon-select': infoReseauxLc.select}"
          @click="contolSelect()">
          <b-icon icon="cart"
          type="is-white" custom-class="icon-position"></b-icon>
        </div>
        <p class="p_size10 has-text-default ml-5px" v-if="!infoReseauxLc.select">
          Sélectionner</p>
        <p class="p_size10 has-text-default ml-5px" v-else>
          Retirer</p>
      </div>
      <div class="has-text-centered mb-btnaction">
        <div class="icon-forme topViolet pointer" @click="show = true">
          <b-icon icon="information"
          type="is-white" custom-class="icon-position"></b-icon>
        </div>
        <p class="p_size10 has-text-default ml-5px">
          Plus d'infos</p>
      </div>
      <div class="has-text-centered topViolet mb-btnaction">
        <app-export-excel
          :data="infoReseauxLc.listeFaces"
          :show-dimension="false"
          :nom="infoReseauxLc.libelle"
          :periode="infoReseauxLc.extensionOpportunite.duree ?
                    infoReseauxLc.extensionOpportunite.duree :
                    'Non renseigné'"/>
      </div>
    </div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-reseaux-lc-complet-diapo
        :bg="bg"
        :detailResauxComplet="infoReseauxLc"
        v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formatNum, urlPhoto } from '@/services/opportunite/formatTab';
import exportExcel from '../../exportExcel';
import detailReseauxLcCompletDiapo from './detailReseauxLcCompletDiapo';


export default {
  name: 'infoReseauxLc',
  props: ['infoReseauxLc'],
  components: {
    appExportExcel: exportExcel,
    appDetailReseauxLcCompletDiapo: detailReseauxLcCompletDiapo,
  },
  data() {
    return {
      show: false,
      bg: false,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.infoReseauxLc.urlPhoto);
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let fraisTechnique = 0;
      let tarifBrut = 0;
      if (this.infoReseauxLc.extensionOpportunite.tarifDePose) {
        tarifDePose = this.infoReseauxLc.extensionOpportunite.tarifDePose;
      }
      if (this.infoReseauxLc.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = this.infoReseauxLc.extensionOpportunite.taxeMunicipale;
      }
      if (this.infoReseauxLc.extensionOpportunite.fraisTechnique) {
        fraisTechnique = this.infoReseauxLc.extensionOpportunite.fraisTechnique;
      }
      if (this.infoReseauxLc.extensionOpportunite.tarifBrut) {
        tarifBrut = this.infoReseauxLc.extensionOpportunite.tarifBrut;
      }
      if (this.infoReseauxLc.extensionOpportunite.tarifNet) {
        tarifNet = this.infoReseauxLc.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
      }
      return tarifBrut
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.infoReseauxLc.select = !this.infoReseauxLc.select;
      if (this.infoReseauxLc.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    tarif(t) {
      return formatNum(t);
    },
  },
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxLc/infoReseauxLc.vue